<template>
  <div>
    <form @submit.prevent="save">
      <div class="modal-card">
        <header class="modal-card-head">
          <p class="modal-card-title">Edit Primary Contact</p>
        </header>
        <section class="modal-card-body">
          <b-message v-if="error" type="is-danger">{{ error }}</b-message>
          <b-message type="is-info">
            Updating the email address invalidates the previous invitation
            and sends a new one to the updated address.
          </b-message>
          <!-- First & Last Name -->
          <div class="columns">
            <div class="column">
              <b-field
                label="First Name"
                :type="('first_name' in errors) ? 'is-danger' : ''"
                :message="('first_name' in errors) ? errors['first_name'][0] : ''">
                <b-input
                  type="text"
                  size="is-medium"
                  v-model="firstName"
                ></b-input>
              </b-field>
            </div>
            <div class="column">
              <b-field
                label="Last Name"
                :type="('last_name' in errors) ? 'is-danger' : ''"
                :message="('last_name' in errors) ? errors['last_name'][0] : ''">
                <b-input
                  type="text"
                  size="is-medium"
                  v-model="lastName"
                ></b-input>
              </b-field>
            </div>
          </div>
          <!-- Email Address -->
          <b-field
            label="Email Address"
            :type="('email' in errors) ? 'is-danger' : ''"
            :message="('email' in errors) ? errors['email'][0] : ''">
            <b-input
              type="email"
              size="is-medium"
              v-model="email"
            ></b-input>
          </b-field>
        </section>
        <footer class="modal-card-foot space-between">
          <b-button @click="$parent.close()">Close</b-button>
          <b-button
            type="is-primary"
            native-type="submit"
            :loading="saving"
            :disabled="saving || !ready">
            Save Contact
          </b-button>
        </footer>
      </div>
    </form>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  data () {
    return {
      firstName: null,
      lastName: null,
      email: null,
      saving: false,
      error: null,
      errors: {}
    }
  },
  computed: {
    ...mapGetters(['context']),
    endpoint () {
      return this.context.route + '/connection-invites/' + this.invitation.id + '/'
    },
    json () {
      return {
        first_name: this.firstName,
        last_name: this.lastName,
        email: this.email
      }
    },
    ready () {
      return Boolean(this.firstName && this.lastName && this.email)
    }
  },
  methods: {
    save () {
      this.saving = true
      this.error = null
      this.errors = {}
      const emailChanged = this.email !== this.invitation.email
      this.$http.patch(this.endpoint, this.json).then(response => {
        if (!emailChanged) {
          return this.onSaved(response.data, 'Primary contact updated!')
        }
        return this.$http.post(this.endpoint + 'resend/').then(() => {
          this.onSaved(response.data, 'Primary contact updated & invitation resent!')
        }).catch(() => {
          this.onSaved(response.data, 'Primary contact updated, but the invitation could not be resent. Please resend it manually.', 'is-warning')
        })
      }).catch(error => {
        if (error.response && error.response.status === 400) {
          this.errors = error.response.data
          if ('non_field_errors' in error.response.data) {
            this.error = error.response.data.non_field_errors[0]
          }
        } else {
          this.error = 'An unexpected error occurred. Please try again.'
        }
      }).finally(() => {
        this.saving = false
      })
    },
    onSaved (invitation, message, type = 'is-success') {
      this.$emit('saved', invitation)
      this.$buefy.toast.open({ type: type, message: message })
      this.$parent.close()
    }
  },
  mounted () {
    this.firstName = this.invitation.first_name
    this.lastName = this.invitation.last_name
    this.email = this.invitation.email
  },
  props: {
    invitation: {
      type: Object,
      required: true
    }
  }
}
</script>
